import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ReactApexChart from "react-apexcharts";
import { tmeChartAnalysisMockData } from "../trainer-member-map/tmeMocksData";
import "../../../styles/trainer-member/tme-trainer-analysis.css";
import "../../../styles/trainer-member/tme-chart-analysis.css";
import {
  fetchBMIChartData,
  fetchMemberWeightData,
} from "../../../redux/prospect-reducers/prospectSlice";
import WeightProgress from "./tme-progress/WeightProgress";
import WeightProfileChart from "./tme-progress/WeightProfileChart";
import WeightLogsDatewise from "./tme-progress/WeightLogsDatewise";
import BMIProfileChart from "./tme-progress/BMIProfileChart";
import BMILogsDatewise from "./tme-progress/BMILogsDatewise";

const TMEChartAnalysis = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();

  const filters = {
    user_id: rowData?.user_id || "",
  };
  // const [filters, setFilters] = useState(iniFilters);

  const hasValidStructure =
    rowData?.progressData &&
    rowData?.weightComparison &&
    rowData?.bmiComparison &&
    rowData?.bcaComparison;
  const data = hasValidStructure ? rowData : tmeChartAnalysisMockData;

  const getMemberWeightStatsData = (filters) => {
    dispatch(
      fetchMemberWeightData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getMemberBMIChartData = (filters) => {
    dispatch(
      fetchBMIChartData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  // Weight Chart Options
  const weightChartOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: ["#3b82f6"],
    xaxis: {
      categories: data.weightComparison.categories,
      labels: {
        style: { colors: "#6b7280", fontSize: "12px" },
      },
    },
    yaxis: {
      min: data.weightComparison.yAxisMin,
      max: data.weightComparison.yAxisMax,
      labels: {
        style: { colors: "#6b7280", fontSize: "12px" },
      },
    },
    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 4,
    },
    markers: {
      size: 6,
      colors: ["#fff"],
      strokeColors: ["#3b82f6"],
      strokeWidth: 2,
      hover: { size: 8 },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val} kg`,
      },
    },
  };

  // BMI Chart Options

  // BCA Chart Options
  const bcaChartOptions = {
    ...weightChartOptions,
    colors: ["#8b5cf6"],
    markers: {
      ...weightChartOptions.markers,
      strokeColors: ["#8b5cf6"],
    },
    xaxis: {
      categories: data.bcaComparison.categories,
      labels: {
        style: { colors: "#6b7280", fontSize: "12px" },
      },
    },
    yaxis: {
      min: data.bcaComparison.yAxisMin,
      max: data.bcaComparison.yAxisMax,
      labels: {
        style: { colors: "#6b7280", fontSize: "12px" },
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val}%`,
      },
    },
  };

  const bcaChartSeries = [
    {
      name: "BCA %",
      data: data.bcaComparison.data,
    },
  ];

  useEffect(() => {
    getMemberWeightStatsData(filters);
    getMemberBMIChartData(filters);
  }, []);

  return (
    <div className="tme-analysis-chart-container">
      {/* Progress Cards Section */}
      <WeightProgress />

      {/* Weight Profile Comparison */}
      <WeightProfileChart />

      {/* Weight Logs Comparison */}
      <WeightLogsDatewise />

      {/* BMI Profile Comparison */}
      <BMIProfileChart />

      {/* BMI Logs Comparison */}
      <BMILogsDatewise />

      {/* BCA Report Comparison */}
      {/* <div className="tme-analysis-chart-comparison-section">
        <h3 className="tme-analysis-chart-section-title">
          BCA Report Comparison
        </h3>
        <div className="tme-analysis-chart-chart-container">
          <ReactApexChart
            options={bcaChartOptions}
            series={bcaChartSeries}
            type="line"
            height={300}
          />
        </div>
      </div> */}

      {/* BCA Logs Comparison */}
      {/* <div className="tme-analysis-chart-logs-section tme-analysis-chart-logs-purple">
        <h4 className="tme-analysis-chart-logs-title">BCA Logs Comparison</h4>
        <div className="tme-analysis-chart-logs-grid">
          {data.bcaComparison.logs.map((log, idx) => (
            <div key={idx} className="tme-analysis-chart-log-card">
              <div className="tme-analysis-chart-log-day">{log.day}</div>
              <div className="tme-analysis-chart-log-date">{log.date}</div>
              <div className="tme-analysis-chart-log-value">{log.value}</div>
              {log.change && (
                <div className="tme-analysis-chart-log-change tme-analysis-chart-change-up">
                  ↗ {log.change}
                </div>
              )}
            </div>
          ))}
        </div>
      </div> */}

      {/* Goal Progress Assessment */}
      {/* <div className="tme-analysis-chart-goal-section">
        <h3 className="tme-analysis-chart-section-title">
          Goal Progress Assessment
        </h3>
        <div className="tme-analysis-chart-goal-card">
          <div className="tme-analysis-chart-goal-row">
            <span className="tme-analysis-chart-goal-label">Member Goal</span>
            <span className="tme-analysis-chart-goal-badge">
              {data.goalAssessment.memberGoal}
            </span>
          </div>
          <div className="tme-analysis-chart-goal-row">
            <span className="tme-analysis-chart-goal-label">Goal Status</span>
            <span className="tme-analysis-chart-goal-status">
              {data.goalAssessment.status}
            </span>
          </div>
          <div className="tme-analysis-chart-goal-row">
            <span className="tme-analysis-chart-goal-label">Weight Lost</span>
            <span className="tme-analysis-chart-goal-weight-lost">
              {data.goalAssessment.weightLost}
            </span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TMEChartAnalysis;
